<div class="row">
  <div class="col-lg-12">
    <app-system-loader [loader]="isLoading"></app-system-loader>
    <div class="ibox" *ngIf="!isLoading && show">
      <div class="ibox-title" [ngClass]="{'box-border': visivel}" (click)="visivel = !visivel">
        <h5>
          <strong>Última atualização: </strong>
          <small *ngIf="atualizacoes.length > 0">{{ atualizacoes[0]?.user_cpf_name }} - {{ atualizacoes[0]?.dt_create }}</small>
          <small *ngIf="atualizacoes.length == 0"><i>sem atualizações</i></small>
        </h5>
        <div class="">
          <i>Ver histórico de atualizações</i>&nbsp;&nbsp;
          <i class="fa fa-chevron-down" *ngIf="!visivel"></i>
          <i class="fa fa-chevron-up" *ngIf="visivel"></i>
        </div>
      </div>
      <div class="ibox-content" *ngIf="visivel">
        <div class="system-table table-container system-table-m-b" *ngIf="atualizacoes.length > 0">
          <div class="system-table-conteiner">
            <table>
              <thead>
                <tr>
                  <th>Usuário / Data</th>
                  <th>Alterações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let atualizacao of atualizacoes">
                  <td class="title">
                    <div> {{ atualizacao.user_cpf_name }}</div>
                    <i>{{ atualizacao.dt_create }}</i>
                  </td>
                  <td>
                    <ul [innerHTML]="atualizacao.summary"></ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>